import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSuggestContentDataTable, createSuggestContent } from './thunks';
import { SuggestContentState } from './types';

export const name = 'suggestContent';

const initialState: SuggestContentState = {
  data: null,
  status: 'idle',
  createSuggestContentStatus: 'idle',
};
export const getSuggestContentDataTableAsync = createAsyncThunk(
  name + '/getSuggestContentDataTable',
  getSuggestContentDataTable
);

export const createSuggestContentAsync = createAsyncThunk(
  name + '/createSuggestContent',
  createSuggestContent
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSuggestContentDataTableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSuggestContentDataTableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getSuggestContentDataTableAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(createSuggestContentAsync.pending, (state) => {
        state.createSuggestContentStatus = 'loading';
      })
      .addCase(createSuggestContentAsync.fulfilled, (state) => {
        state.createSuggestContentStatus = 'idle';
      })
      .addCase(createSuggestContentAsync.rejected, (state) => {
        state.createSuggestContentStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
